import styled, { css } from "styled-components";

export default function ParameterCard(props) {
    const { id, name, type, units = [], ...restProps } = props;
    return (
        <Styled
            as={ props.onClick ? "button" : "div" }
            { ...restProps }
        >
            <span className="name">{ name }</span>
            <span className="units">{ units.join(", ") }</span>
            <span className="type">{ type }</span>
        </Styled>
    );
}

const Styled = styled.button`
    //align-items: flex-start;
    background: transparent;
    color: #000;
    border: 1px solid transparent;
    border-radius: 2px;
    cursor: default;
    //display: flex;
    //flex-direction: column;
    gap: 8px;
    padding: 8px 24px 8px 16px;
    transition: 200ms;
    text-align: left;

    .name {
        font-size: 1.2em;
        font-family: var(--font-mono), monospace;
    }

    .units {
        font-size: .8em;
        font-family: var(--font-mono), monospace;

        &::after {
            content: "]";
        }

        &::before {
            content: " [";
        }

        &:empty {
            display: none;
        }
    }

    .type {
        color: #0009;
        display: block;
        font-size: .7em;
        font-family: var(--font-mono), monospace;
        user-select: none;

        &:empty {
            display: none;
        }
    }

    &:disabled {
        opacity: .4;
    }

    ${ ({ onClick }) => onClick && CSSClickable }
`;

const CSSClickable = css`
    &:enabled {
        cursor: pointer;

        &:hover {
            .name {
                text-decoration: underline;
            }
        }
    }
`;
